import type { IconData } from '@stacksjs/iconify-core'

export const computerAltF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1 14h18a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2M2 0h16a2 2 0 0 1 2 2v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default computerAltF
